export default __webpack_public_path__ + "814e9653f0e629f94f8c4e585b5c2f55.gif";